import { FilterValueType } from "@/components/StructuredSearch/config/structured-search-schema";
import type { Filter } from "@/components/StructuredSearch/config/types";
import type { StructuredSearchStore } from "@/components/StructuredSearch/stores/structured-search/structured-search-store";

export interface NestedKeyEqualsStructuredFilterDetail {
  field: string;
  nestedKey: string;
  nestedKeyDisplay?: string;
  value: string;
  valueDisplay?: string;
}

const hasMatchingNestedKeyEqualsFilter = (
  filters: Filter[],
  { field, nestedKey, value }: NestedKeyEqualsStructuredFilterDetail,
) =>
  filters.some(
    filter =>
      filter.field === field &&
      filter.type === FilterValueType.Nested &&
      filter.operator === "key_equals" &&
      filter.nestedKey === nestedKey &&
      filter.value === value,
  );

export const appendNestedKeyEqualsStructuredFilter = (
  structuredSearchStore: StructuredSearchStore,
  detail: NestedKeyEqualsStructuredFilterDetail,
): boolean => {
  const field = detail.field.trim();
  const nestedKey = detail.nestedKey.trim();
  const value = detail.value.trim();

  if (!field || !nestedKey || !value) {
    return false;
  }

  if (
    hasMatchingNestedKeyEqualsFilter(structuredSearchStore.filters, { field, nestedKey, value })
  ) {
    return false;
  }

  const nextFilter: Filter = {
    id: crypto.randomUUID(),
    field,
    type: FilterValueType.Nested,
    operator: "key_equals",
    value,
    valueDisplay: detail.valueDisplay ?? value,
    nestedKey,
    nestedKeyDisplay: detail.nestedKeyDisplay,
  };

  structuredSearchStore.cancelBuilder();
  structuredSearchStore.setFiltersFromURL([...structuredSearchStore.filters, nextFilter]);
  structuredSearchStore.resetToFirstPage();

  return true;
};
